import React, { useState } from 'react';
import { ButtonContact, SectionHeading } from '../../components';
import './homePage.css';

import heroCityImg from '../../assets/home/hero-city.png';
import aboutSideImg from '../../assets/home/about-side.png';
import acquireTextImg from '../../assets/home/acquire-text.png';
import valuesBgImg from '../../assets/home/values-bg.png';
import portfolioRealEstate from '../../assets/home/portfolio-realestate.png';
import portfolioImg2 from '../../assets/home/portfolio-2.png';
import portfolioImg3 from '../../assets/home/portfolio-3.png';
import portfolioImg4 from '../../assets/home/portfolio-4.png';
import contactBgImg from '../../assets/home/contact-bg.png';

import greenCircle from '../../assets/icons/green-circle.svg';
import arrowRightWhite from '../../assets/icons/arrow-right-white.svg';
import contactEmailIcon from '../../assets/icons/contact-email.svg';
import contactPhoneIcon from '../../assets/icons/contact-phone.svg';
import contactLocationIcon from '../../assets/icons/contact-location.svg';

const valuesData = [
  {
    title: 'Uncompromising Excellence',
    subtitle: 'We set the standard across every industry we touch.',
    desc: 'We pursue excellence in everything we do. We challenge ourselves to continuously innovate, raise our benchmarks, and never settle for average. Across our global operations\u2014every customer interaction, every venture, and every strategic decision is an opportunity to outpace yesterday.',
  },
  {
    title: 'Integrity & Trust',
    subtitle: 'Doing the right thing is our foundation.',
    desc: 'Trust is earned through transparency and integrity. We do the right thing, even when no one is watching. We remain honest with our global clients, accountable to our partners, and fiercely committed to protecting the stellar reputation of the Kothawala brand network.',
  },
  {
    title: 'A People-First Culture',
    subtitle: 'Great enterprises are built by investing in extraordinary talent.',
    desc: 'We believe that our greatest asset is our people. We care about our employees as individuals, nurturing an environment of mutual respect, psychological safety, and open communication. We foster a workplace where every voice is heard, valued, and empowered to thrive.',
  },
  {
    title: 'Cultivating Future Leaders',
    subtitle: 'We grow people, and people grow our business.',
    desc: 'Professional evolution starts from within. Through continuous coaching, structured training, and clear paths for internal advancement, we transform driven professionals into industry leaders. We invest heavily in our team members because their personal growth directly fuels our global success.',
  },
  {
    title: 'Consistency Drives Success',
    subtitle: 'Long-term impact is built through disciplined execution.',
    desc: 'Extraordinary results are not accidental; they are achieved through reliable performance, disciplined operational habits, and a daily commitment to improvement. At Kothawala Group, we believe that relentless consistency creates lasting value\u2014for our customers, our teams, and our global ecosystem.',
  },
];

const portfolioData = [
  { image: portfolioRealEstate, tagline: 'The perfect deal, secured.', name: 'Real Estate' },
  { image: portfolioImg2, tagline: 'Building tomorrow, today.', name: 'Construction' },
  { image: portfolioImg3, tagline: 'Driving innovation forward.', name: 'Automotive' },
  { image: portfolioImg4, tagline: 'Crafting memorable experiences.', name: 'Hospitality' },
];

const HomePage = () => {
  const [contactForm, setContactForm] = useState({ name: '', email: '', message: '' });
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleContactChange = (e) => {
    setContactForm({ ...contactForm, [e.target.name]: e.target.value });
  };

  return (
    <div className="kw__home">
      {/* ───── Hero ───── */}
      <section className="kw__hero">
        <div className="kw__hero_bg">
          <img src={heroCityImg} alt="City skyline at dusk" />
        </div>
        <div className="kw__hero_content">
          <h1 className="kw__hero_title">
            Operational Powerhouse for<br />
            Excellence &amp; Structured Growth
          </h1>
          <p className="kw__hero_text">
            Kothawala Group drives business performance toward measurable,
            significant outcomes by transforming complex operations into
            high-performance systems. We take control where it counts,
            embedding ourselves in your business to eliminate inefficiencies
            and rebuild systems from the ground up. Our experts handle every
            detail, addressing operational bottlenecks to unlock greater
            performance. By aligning elite strategy with aggressive expansion,
            we ensure growth is unstoppable and give investors the confidence
            to capture exponential results. This is where giants build
            long-term excellence.
          </p>
          <ButtonContact to="/sell-your-business">Partner With Us</ButtonContact>
        </div>
        <img className="kw__hero_circle" src={greenCircle} alt="" aria-hidden="true" />
      </section>

      {/* ───── About Us ───── */}
      <section className="kw__about">
        <div className="kw__about_inner">
          <div className="kw__about_content">
            <p className="kw__about_label">About Us</p>
            <h2 className="kw__about_title">Delivering for Investors</h2>
            <div className="kw__about_desc">
              <p>
                Ambition, when backed by decisive capital and disciplined execution, turns into market leadership. That&apos;s where Kothawala Group operates—building, scaling, and strengthening businesses across high-growth industries with sharp strategy and commercial clarity. Our approach is performance-led: expand with control, perform with consistency, and deliver strong, lasting returns.
              </p>
              <ul>
                <li>Multi-industry business development platform</li>
                <li>Investor-focused, scalable enterprise model</li>
                <li>Execution-led operational architecture</li>
                <li>Global expansion-oriented strategy</li>
                <li>Long-term value creation mindset</li>
              </ul>
              <p>
                We are not defined by sectors—we are defined by the ability to build, scale, and strengthen businesses that perform across them.
              </p>
            </div>
          </div>
          <div className="kw__about_image">
            <img src={aboutSideImg} alt="Modern building" />
          </div>
        </div>
      </section>

      {/* ───── Mission / Vision ───── */}
      <section className="kw__mission">
        <div className="kw__mission_inner">
          <h2
            className="kw__mission_headline"
            style={{ backgroundImage: `url(${acquireTextImg})` }}
          >
            Acquire.&nbsp;&nbsp;Optimize.&nbsp;&nbsp;Elevate.
          </h2>
          <p className="kw__mission_subtitle">
            Beyond Acquisitions. Building Operating Platforms for Long-Term Success.
          </p>
          <div className="kw__mission_blocks">
            <div>
              <h3 className="kw__mission_block-title">Our Mission</h3>
              <p className="kw__mission_block-text">
                Our mission is to acquire, build, and scale high-potential businesses into industry-leading enterprises driven by strong systems, exceptional people, advanced technology, and disciplined execution. We eliminate inefficiencies, accelerate growth, and build organizations designed for long-term dominance. We transform proven companies into powerful, professionally managed enterprises that deliver lasting value.
              </p>
            </div>
            <div>
              <h3 className="kw__mission_block-title">Our Vision</h3>
              <p className="kw__mission_block-text">
                Our vision is to become a leading force in building world-class enterprises by transforming businesses into scalable, future-ready organizations that set new standards of performance, efficiency, and long-term value creation. We envision a portfolio of industry-leading companies that consistently outperform markets, empower people, and create lasting impact for investors, communities, and future generations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ───── Our Values ───── */}
      <section className="kw__values">
        <div className="kw__values_card">
          <img className="kw__values_bg" src={valuesBgImg} alt="" aria-hidden="true" />
          <div className="kw__values_overlay">
            <div className="kw__values_header">
              <p className="kw__values_header-label">Our Values:</p>
              <p className="kw__values_header-text">
                Our commitment to trust, innovation, and lasting value defines who we are.
              </p>
            </div>

            {valuesData.map((item, i) => (
              <div key={item.title} className={`kw__values_item kw__values_item--${i}`}>
                <h3 className="kw__values_item-title">{item.title}</h3>
                <p className="kw__values_item-subtitle">{item.subtitle}</p>
                <p className="kw__values_item-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ───── Our Portfolio ───── */}
      <section className="kw__portfolio">
        <div className="kw__portfolio_inner">
          <SectionHeading
            label="OUR PORTFOLIO"
            title="Driving Progress Across Diverse Industries"
            description="We manage a resilient portfolio spanning vital sectors of the global economy. From physical infrastructure and digital enterprise to consumer lifestyle and community welfare, our businesses are built on universal adaptability, operational excellence, and sustainable growth."
            align="center"
          />
          <div className="kw__portfolio_grid">
            {portfolioData.map((card, i) => (
              <div
                key={card.name}
                className={`kw__portfolio_card${hoveredCard === i ? ' kw__portfolio_card--active' : ''}`}
                onMouseEnter={() => setHoveredCard(i)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <img src={card.image} alt={card.name} />
                <div className="kw__portfolio_card-gradient" />
                <div className="kw__portfolio_card-text">
                  <p className="kw__portfolio_card-tagline">{card.tagline}</p>
                  <p className="kw__portfolio_card-name">{card.name}</p>
                </div>
              </div>
            ))}
          </div>
          <ButtonContact to="/portfolio" variant="dark">View All Works</ButtonContact>
        </div>
      </section>

      {/* ───── Featured Stories ───── */}
      <section className="kw__stories">
        <div className="kw__stories_inner">
          <h2 className="kw__stories_title">Featured Stories</h2>
          <p className="kw__stories_subtitle">
            Discover more about how we shape industries and empower businesses.
          </p>
          <div className="kw__stories_grid">
            <div className="kw__stories_card kw__stories_card--coming-soon">
              <p className="kw__stories_coming-soon">Coming Soon</p>
            </div>
          </div>
        </div>
      </section>

      {/* ───── Contact Us ───── */}
      <section className="kw__contact">
        <div className="kw__contact_bg">
          <img src={contactBgImg} alt="" aria-hidden="true" />
        </div>
        <div className="kw__contact_inner">
          <p className="kw__contact_label">Contact us</p>
          <div className="kw__contact_row">
            <div className="kw__contact_left">
              <h2 className="kw__contact_heading">
                Let&apos;s Build Something Remarkable Together
              </h2>
              <div className="kw__contact_info-card">
                <div className="kw__contact_info-icon">
                  <img src={contactEmailIcon} alt="" />
                </div>
                <div className="kw__contact_info-body">
                  <div className="kw__contact_info-details">
                    <span className="kw__contact_info-label">Email</span>
                    <span className="kw__contact_info-value">admin@kothawalagroup.com</span>
                  </div>
                  <div className="kw__contact_info-arrow">
                    <img src={arrowRightWhite} alt="" />
                  </div>
                </div>
              </div>
              <div className="kw__contact_info-card">
                <div className="kw__contact_info-icon">
                  <img src={contactPhoneIcon} alt="" />
                </div>
                <div className="kw__contact_info-body">
                  <div className="kw__contact_info-details">
                    <span className="kw__contact_info-label">Phone Number</span>
                    <span className="kw__contact_info-value">+1 (346) 547-4580</span>
                  </div>
                  <div className="kw__contact_info-arrow">
                    <img src={arrowRightWhite} alt="" />
                  </div>
                </div>
              </div>
              <div className="kw__contact_info-card">
                <div className="kw__contact_info-icon">
                  <img src={contactLocationIcon} alt="" />
                </div>
                <div className="kw__contact_info-body">
                  <div className="kw__contact_info-details">
                    <span className="kw__contact_info-label">Location</span>
                    <span className="kw__contact_info-value">Houston, Texas</span>
                  </div>
                  <div className="kw__contact_info-arrow">
                    <img src={arrowRightWhite} alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="kw__contact_right">
              <input
                className="kw__contact_input"
                type="text"
                name="name"
                placeholder="Name"
                value={contactForm.name}
                onChange={handleContactChange}
              />
              <input
                className="kw__contact_input"
                type="email"
                name="email"
                placeholder="Email"
                value={contactForm.email}
                onChange={handleContactChange}
              />
              <textarea
                className="kw__contact_textarea"
                name="message"
                placeholder="Message"
                value={contactForm.message}
                onChange={handleContactChange}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
